import { Link } from "react-router-dom";
import type { Video } from "@/types/video";

interface VideoCardProps {
  video: Video;
  rank?: number;
}

export default function VideoCard({ video, rank }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer"
      data-product-shop
      aria-label={video.title}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title}海报`}
          title={`${video.title} - 芭乐视频高清影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-80" />
        {rank ? (
          <span className="absolute top-2 left-2 flex items-center justify-center w-6 h-6 rounded-md bg-primary-500 text-background-50 text-xs font-heading font-bold">
            {rank}
          </span>
        ) : null}
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 text-[11px] font-label backdrop-blur-sm">
          {video.episodes}
        </span>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between text-background-50 text-[11px] font-label">
          <span className="flex items-center gap-1">
            <i className="ri-fire-fill text-accent-400" />
            {(video.heat / 1000).toFixed(1)}k
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" />
            {video.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="flex items-center justify-center w-11 h-11 rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl" />
          </span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {video.type} · {video.region} · {video.year}
        </p>
        <p className="mt-0.5 text-xs text-foreground-400 truncate">{video.genre.join(" / ")}</p>
      </div>
    </Link>
  );
}